import { motion } from 'framer-motion'
import AddAgentWizard from '../AddAgentWizard'

// The Build tab: configure a specialist agent (name, description, system prompt,
// data source), verify the orchestrator routes to it, then publish. Reuses the
// AddAgentWizard flow inline — same verify/publish logic as the Agents modal.
export default function BuildAgent({ onCreated = () => {} }) {
  return (
    <>
      <motion.div
        className="page-head"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      >
        <div>
          <div className="eyebrow">Build</div>
          <h1>Build an agent</h1>
          <p className="sub">Configure a specialist, pick its data source, verify routing, then publish it live.</p>
        </div>
      </motion.div>

      <div className="section-label">New agent</div>
      <AddAgentWizard inline onCreated={onCreated} />
    </>
  )
}
